<template>
    <v-autocomplete
        v-model="resolvedUbigeo"
        :items="ubigeoItems"
        :loading="ubigeoLoading"
        :search-input.sync="ubigeoSearch"
        :item-text="ubigeoLabel"
        item-value="id"
        return-object
        :label="label"
        no-data-text="Escribe para buscar..."
        :dense="dense"
        :outlined="outlined"
        :disabled="disabled"
        :rules="rules"
        :clearable="clearable"
        @change="onSelect"
    />
</template>

<script>
export default {
    name: 'SelectUbigeo',
    props: {
        value: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: 'Distrito'
        },
        dense: {
            type: Boolean,
            default: true
        },
        outlined: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: true
        },
        rules: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            resolvedUbigeo: null,
            ubigeoSearch: '',
            ubigeoItems: [],
            ubigeoLoading: false,
            searchTimeout: null
        }
    },
    watch: {
        value: {
            async handler(val) {
                if (!val) {
                    this.resolvedUbigeo = null
                    this.ubigeoItems = []
                    return
                }
                // If the current resolved object already matches, skip hydration
                if (this.resolvedUbigeo && this.resolvedUbigeo.id === val) return
                // Hydrate from id
                this.ubigeoLoading = true
                try {
                    const found = await this.$store.dispatch('sedes/getUbigeoById', val)
                    if (found && found.length > 0) {
                        this.resolvedUbigeo = found[0]
                        this.ubigeoItems = [found[0]]
                    }
                } finally {
                    this.ubigeoLoading = false
                }
            },
            immediate: true
        },
        ubigeoSearch(val) {
            clearTimeout(this.searchTimeout)
            // Ignore when value equals the label of the already-selected item
            if (this.resolvedUbigeo && val === this.ubigeoLabel(this.resolvedUbigeo)) return
            if (!val || val.length < 2) return
            this.searchTimeout = setTimeout(async () => {
                this.ubigeoLoading = true
                try {
                    this.ubigeoItems = await this.$store.dispatch('sedes/searchDistrito', val)
                } finally {
                    this.ubigeoLoading = false
                }
            }, 300)
        }
    },
    methods: {
        ubigeoLabel(item) {
            return `${item.distrito} / ${item.provincia} / ${item.departamento}`
        },
        onSelect(item) {
            if (!item) {
                this.$emit('input', null)
                this.$emit('change-full', null)
                return
            }
            this.$emit('input', item.id)
            this.$emit('change-full', { id: item.id, distrito: item.distrito, provincia: item.provincia, departamento: item.departamento })
        }
    }
}
</script>
